export enum PuzzleTypeIdEnum {
  CROSSWORD_1 = '1', // Schwedenrätsel standard
  CROSSWORD_20 = '20', // Schüttel-Schwedenrätsel
  CROSSWORD_221 = '221', // Kreuzworträtsel mit Wortliste (waag. + senkr. nach Länge)
  CROSSWORD_252 = '252', // Gitterrätsel mit Wörtern
  CROSSWORD_265 = '265', // Gitterrätsel mit Definitionsliste
  CROSSWORD_310 = '310', // Kombirätsel klassisch ("Um die Ecke gedacht") Strichen
  CROSSWORD_770 = '770', // Brückenrätsel
  CROSSWORD_771 = '771', // Brückenrätsel flexibel, gleich wie 770 nur die Brückenwörter können Leer-/Trennfelder enthalten
  WORD_SEARCH_600 = '600', // Wörtersuchen
  SUDOKU_900 = '900', //
  HASHI = '950', // Hashiwokakero
  QUIZ_1000 = '1000', // Quiz
  IMAGE_PUZZLE = 'imagepuzzle', // Bilderrätsel
  ERROR = 'error',
}
